var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"processesWrapper"}},[_c('ul',_vm._l((_vm.processes),function(process,idx){return _c('process',{key:idx,attrs:{"process":process}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }